module.exports = __webpack_public_path__ + "static/media/design-do-site.1db3e1a8.svg";